// extracted by mini-css-extract-plugin
export default {"btn_zamowienia_menu_row":"ZamknijBTN_btn_zamowienia_menu_row__e79ci"};